export default __webpack_public_path__ + "static/media/1223.41180a39.png";